import {Close, Content, DialogContentProps, Portal, Root, Title, Trigger} from '@radix-ui/react-dialog';
import React from 'react';

import {cn} from '../../utils/utils';

export const DialogContent = React.forwardRef(
  ({children, className, ...props}, forwardedRef) => (
    <Portal>
      <div className="fixed inset-0 z-20 bg-gray-900 backgro opacity-[0.85]" />
      <div className="fixed inset-0 z-20 backdrop-blur-sm" />

      <Content
        className={cn(
          'overflow-y-auto fixed top-1/2 left-1/2 z-20 p-8 bg-white rounded shadow-xl -translate-x-1/2 -translate-y-1/2',
          className
        )}
        {...props}
        ref={forwardedRef}
      >
        {children}
      </Content>
    </Portal>
  )
);

// Layout compuesto: header + body (scroll) + footer (fijo).
// Usar junto a DialogContent con `p-0 flex flex-col max-h-[85vh] overflow-hidden`.
export const DialogHeader = ({ className, ...props }) => (
  <div
    className={cn("shrink-0 px-6 pt-6 pb-4 border-b border-gray-100", className)}
    {...props}
  />
);

export const DialogBody = ({ className, ...props }) => (
  <div
    className={cn("flex-1 min-h-0 overflow-y-auto px-6 py-4", className)}
    {...props}
  />
);

export const DialogFooter = ({ className, ...props }) => (
  <div
    className={cn(
      "shrink-0 px-6 py-4 border-t border-gray-100 flex justify-end gap-2 bg-white",
      className
    )}
    {...props}
  />
);

export const Dialog = Root;
export const DialogTrigger = Trigger;
export const DialogClose = Close;
export const DialogTitle = Title;
